const evalNavBtns = document.querySelectorAll('.tab-links button');

export function evalNavigation() {
    evalNavBtns.forEach(function(button){
        button.addEventListener('click', function() {
            if (!button.classList.contains('active')) {
                let prevPriBtn = document.querySelector('.tab-links .btn-primary');
                let btnAria = button.getAttribute('aria-controls');
                prevPriBtn.classList.remove('btn-primary');
                prevPriBtn.classList.add('btn-secondary');
                button.classList.remove('btn-secondary');
                button.classList.add('btn-primary');
                document.querySelector('.acc-info.active').classList.remove('active');
                document.getElementById(btnAria).classList.add('active');
            }
        })
    })
}
